export enum Currency {
  CZK = 'CZK',
  EUR = 'EUR',
}

export const currencies = [Currency.CZK, Currency.EUR];
